export const namespace = 'tenants';

export const MutationTypes = {
  SET_TENANTS: 'SET_TENANTS',
  SET_ALL_TENANTS: 'SET_ALL_TENANTS',
  SET_TENANT_HISTORY: 'SET_TENANT_HISTORY',
};

export const ActionTypes = {
  GET_TENANTS: 'GET_TENANTS',
  GET_ALL_TENANTS: 'GET_ALL_TENANTS',
  GET_TENANT_HISTORY: 'GET_TENANT_HISTORY',
};
